export default function HeroSection() {
  return (
    <section id="top" className="relative pt-28 md:pt-36 pb-16 md:pb-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 xl:px-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 items-center">
          <div className="lg:col-span-7 reveal reveal-1">
            <span className="inline-flex items-center gap-2 text-xs md:text-sm text-primary-700 bg-primary-100 px-3 py-1.5 rounded-full">
              <i className="ri-smartphone-line text-sm"></i>
              手机版 · 安卓端 · 持续更新
            </span>

            <h1 className="mt-5 font-heading font-bold text-3xl md:text-5xl leading-tight md:leading-[1.15] text-foreground-950 text-balance">
              91浏览器手机版下载
              <br className="hidden md:block" />
              安卓最新版安装包一次找齐
            </h1>

            <p className="mt-5 text-base md:text-lg leading-relaxed text-foreground-600 max-w-xl">
              内存小、看片卡顿的日子，该翻篇了。这里把
              <strong className="text-foreground-900 font-medium">安卓版、最新版与安装包</strong>
              的下载入口集中摆在一起，初次接触或老用户升级，都能照着指引一步步装好，换来更轻快的浏览与播放。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row sm:items-center gap-3 md:gap-4">
              <a
                href="#versions"
                className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium px-6 py-3.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-download-2-line text-lg"></i>
                下载安卓版
              </a>
              <a
                href="#versions"
                className="inline-flex items-center justify-center gap-2 bg-background-100 hover:bg-background-200 border border-background-300 text-foreground-900 font-medium px-6 py-3.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-file-zip-line text-lg"></i>
                获取最新版安装包
              </a>
            </div>

            <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-4">
              <div className="flex items-center gap-2.5">
                <span className="w-9 h-9 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
                  <i className="ri-checkbox-circle-line text-lg"></i>
                </span>
                <span className="text-sm text-foreground-600">适配 Android 7.0 及以上</span>
              </div>
              <div className="flex items-center gap-2.5">
                <span className="w-9 h-9 rounded-md bg-secondary-100 text-secondary-800 flex items-center justify-center">
                  <i className="ri-database-2-line text-lg"></i>
                </span>
                <span className="text-sm text-foreground-600">安装包约 42MB</span>
              </div>
              <div className="flex items-center gap-2.5">
                <span className="w-9 h-9 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
                  <i className="ri-refresh-line text-lg"></i>
                </span>
                <span className="text-sm text-foreground-600">支持旧版平滑升级</span>
              </div>
            </div>
          </div>

          <div className="lg:col-span-5 reveal reveal-3">
            <div className="relative w-full max-w-[420px] mx-auto">
              <div className="w-full aspect-[4/5] rounded-lg overflow-hidden bg-background-100 border border-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20stylized%20illustration%20of%20a%20modern%20smartphone%20displaying%20a%20clean%20minimal%20web%20browser%20interface%2C%20floating%20on%20a%20soft%20warm%20amber%20gradient%20background%2C%20gentle%20geometric%20shapes%20and%20thin%20outlines%2C%20editorial%20technology%20visual%2C%20harmonious%20warm%20tones%2C%20high%20detail%2C%20no%20text%2C%20soft%20diffused%20lighting%2C%20minimal%20composition&width=720&height=900&seq=91br-hero-visual&orientation=portrait"
                  alt="91浏览器手机版界面示意，安卓最新版安装包下载"
                  title="91浏览器手机版 + 安卓安装包"
                  className="w-full h-full object-top"
                />
              </div>

              <div className="absolute -left-3 md:-left-6 top-16 bg-background-50 border border-background-200 rounded-md px-4 py-3 animate-float">
                <p className="text-xs text-foreground-500">打开速度</p>
                <p className="font-heading font-bold text-lg text-accent-600">更快一步</p>
              </div>
              <div className="absolute -right-3 md:-right-5 bottom-14 bg-background-50 border border-background-200 rounded-md px-4 py-3 animate-float">
                <p className="text-xs text-foreground-500">占用内存</p>
                <p className="font-heading font-bold text-lg text-primary-600">更轻盈</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}